import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RenaultAnimationActionGoalMatrixDTO } from '../../../models/renault-animation-action-dto';
import { AnimationActionService } from '../../../services/animation-action.service';

@Component({
  selector: 'animation-action-goal-matrix',
  templateUrl: './animation-action-goal-matrix.component.html',
  styleUrls: ['./animation-action-goal-matrix.component.scss']
})
export class AnimationActionGoalMatrixComponent implements OnInit {

  @Input() idAction: string;
  @Input() idPpvGroup: number;
  model: RenaultAnimationActionGoalMatrixDTO;

  constructor(public activeModal: NgbActiveModal,
    private service: AnimationActionService) { }

  ngOnInit(): void {

    if (this.idPpvGroup) {
      this.service.getAnimationActionGoalMatrixMyZone(this.idAction, this.idPpvGroup).subscribe(resp => {
        this.model = resp;
      });
    } else {
      this.service.getAnimationActionGoalMatrix(this.idAction).subscribe(resp => {
        this.model = resp;
      });
    }


  }

}
